import { createFileRoute } from "@tanstack/react-router";
import { UsersTab } from "@/components/admin/UsersTab";

export const Route = createFileRoute("/admin/users")({
  head: () => ({ meta: [{ title: "Users · Admin · INFLOW Marketing" }, { name: "description", content: "Manage admin user access, roles, and permissions for the INFLOW Marketing dashboard." }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Users</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage admin access to the dashboard.</p>
      </div>
      <UsersTab />
    </div>
  ),
});
